import React from 'react'
import ReactDOM from 'react-dom/client'
import App from './App.tsx'
import './index.css'
import { enableAutoSEO } from './utils/autoSEO'

// 🚀 ULTIMATE SEO AUTOMATION - Just this one line!
enableAutoSEO();

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
)